import {ApolloCache, gql} from "@apollo/client";
import {Account, Editor, Student} from "../../schema";
import {AppAccountFragment, AppUserFragment} from "../../App.graphql";

export function loginUpdateCache(
  cache: ApolloCache<any>,
  {user, account}: {user?: Student | Editor; account?: Account},
) {
  if (user) {
    cache.writeFragment({
      id: cache.identify(user),
      fragment: AppUserFragment,
      data: user,
    });
  }

  if (account) {
    cache.writeFragment({
      id: cache.identify(account),
      fragment: AppAccountFragment,
      data: account,
    });
  }

  cache.writeQuery({
    query: gql`
      query {
        user: getCurrentUser {
          id
          __typename
        }
        account: getCurrentAccount {
          id
          __typename
        }
      }
    `,
    data: {
      user: user ? {id: user.id, __typename: user.__typename} : null,
      account: account ? {id: account.id, __typename: account.__typename} : null,
    },
  });
}
